import React, {Component} from 'react'
import styled from 'styled-components'
import { findProducts, ProductImage, Category } from 'product_tools'
import { DataStore, getGlobal } from 'launchpad'
import { Link } from 'widgets'

// TODO: may want to optionally have product galleries be independent of specific products
//const PG = new DataStore('productGalleries')


const PSContainer = styled.div`
  input {
    padding: 7px 12px;
  }

  .results {
    background: white;
    position: absolute;
    z-index: 2;
    .result {
      padding: 3px 10px;
      border: 1px solid #eee;
      .fa {
        margin-right: 10px;
      }
      &:hover {
        background: #eee;
        cursor: pointer;
      }
    }
  }
`

export class ProductSelector extends Component {
  state = {query: '', focused: false}

  select = (id) => {
    this.setState({query: ''})
    this.props.onSelect(id)
  }

  blur = () => {
    setTimeout(()=>this.setState({query: '', focused: false}), 100)
  }

  render() {
    const { query } = this.state
    const { category_name } = this.props
    const data = category_name ? {category_name} : {}
    const results = query.length > 1 ? findProducts(Object.assign({name: query, limit: 5}, data)) : []

    return <PSContainer className='product-selector'>
      <input placeholder='+ Add Products'
        onBlur={this.blur}
        onFocus={()=>this.setState({focused: true})}
        onChange={e => this.setState({query: e.target.value})}
        value={query}
      />
      <div className='results'>
        {this.state.focused && !results.length && query.length < 2 && <div className='result'>
          <span className='fa fa-arrow-right' /> Enter {2-query.length} more characters to search
          </div>}
        {this.state.focused && !results.length && query.length >= 2 && <div className='result'>
          <span className='fa fa-ban' /> No results found
        </div>}
        {results.map(p => <div key={p._id} className='result' onClick={() => this.select(p._id)}>
          <span className='fa fa-plus' /> {p.name}
        </div>)}
      </div>
    </PSContainer>
  }
}


const PBContainer = styled.div`
  border: 1px solid #eee;
  position: relative;

  a {
    height: 100%;
    display: flex;
    flex-direction: column;

    .image {
      margin-top: auto;
      margin-bottom: auto;
    }

    .info {
      padding: 20px 10px;
      width: 100%;
      text-align: center;
    }
  }

  .remove.fa-close {
    position: absolute;
    top: 10px;
    left: 10px;
    opacity: 0;
    transition: opacity .3s;
    cursor: pointer;
  }

  &:hover {
    .remove.fa-close {
      opacity: 1;
    }
  }
`

let categories = {}

const ProductBox = props => {
  const { product, className, onRemove } = props
  const p = product
  if(!p) return <span />
  if(!categories[p.category._id]) categories[p.category._id] = new Category(p.category)
  const c = categories[p.category._id]
  let url = c.url+'/'+p.url
  if(!url.startsWith('/')) url = '/'+url
  return <PBContainer className={`product-box ${className}`}>
    <Link to={url} className='product-container'>
      <ProductImage backgroundColor='white' className='image' category={c} series={p._id} seriesName={p.name} subcategoryName={p.subcategory} />
      <div className='info'>
        <div className='pb-title'>{p.name}</div>
      </div>
    </Link>
    {onRemove && getGlobal('is_admin') && <div className='fa fa-close remove' onClick={onRemove}/>}
  </PBContainer>
}



const Container = styled.div`
  .muted {
    color: #ddd;
  }

  .products {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    .product {
      flex: 1;
      margin-right: 10px;
      margin-bottom: 10px;
      max-width: calc(20% - 20px);
      &:first-child {
        margin-left: 0;
      }
      &:last-child {
        margin-right: 0;
      }
    }
  }

  @media (max-width: 812px) {
    .products {
      .product {
        width: calc(50% - 5px);
        max-width: calc(50% - 5px);
        flex-basis: 50%;
        &:nth-child(2n) {
          margin-right: 0;
        }
      }
    }
  }
`

export default class ProductGallery extends Component {
  getProducts = () => {
    return (this.props.gallery || []).filter(x=>!!x)
  }

  addProduct = (id) => {
    this.props.onChange(this.getProducts().concat([id]).filter(x=>!!x))
  }

  removeProduct = (idx) => {
    let products = this.getProducts()
    products.splice(idx, 1)
    this.props.onChange(products)
  }

  render() {
    const products = this.getProducts()
    return <Container>
      {getGlobal('is_admin') && <ProductSelector category_name={this.props.category_name} onSelect={p => this.addProduct(p)}/>}
      {getGlobal('is_admin') && !products.length && <h2 className='muted'>No products selected</h2>}
      <div className='products'>
        {products.map((p, idx) => <ProductBox
            className='product'
            key={`${p}${idx}`}
            product={findProducts({_id: p})}
            onRemove={()=>this.removeProduct(idx)}
          />
        )}
      </div>
    </Container>
  }
}



export class RelatedProducts extends Component {
  render(){
    const {product, category} = this.props
    const acc = category == 'Accessories'
    const field = acc ? 'accessories' : 'related'
    return <ProductGallery onChange={v=>product.update({[field]: v})} gallery={product[field]} category_name={category} />
  }
}
